import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import { ModuleState } from '@redux/modules/types'

import InvoiceEditRoutes from './routes'

const InvoiceEdit = () => {
  const { invoiceId } = useNumericParams()

  useReduxAction(
    'invoices',
    'loadInvoice',
    {
      entityId: invoiceId,
      include_agency_image: true,
      include_booking_admin_links: true,
      include_brand_logo: true,
      include_invoice_attachment_file: true,
      include_invoice_attachments: true,
      include_invoice_booking: true,
      include_invoice_campaign: true,
      include_invoice_debtor: true,
      include_invoice_items: true,
      include_invoice_package: true,
      include_invoice_users: true,
      include_provider_logo: true,
    },
    [invoiceId],
    {
      dispatchAction: (action, requestOptions) => action(invoiceId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }: ModuleState) => invoiceId && !loading,
    },
  )

  return (
    <InvoiceEditRoutes />
  )
}

export default InvoiceEdit
